import React from 'react';
import { useTranslation } from 'react-i18next';

import { Row, Domain, PriceCluster, Price, FreeTag } from './DomainRow.styles';

export interface DomainRowProps {
  domain: string;
  /** Pre-formatted list price ("Free" or "2,000$/year"). */
  priceLabel: string;
  /** True when the domain has no list price to begin with (nothing to strike). */
  free: boolean;
  selected: boolean;
  onSelect: () => void;
}

/** A single AI domain suggestion row: domain · struck-out list price + a green
 *  "Free" tag (every suggested domain is free during onboarding). Domains with
 *  no list price show only the tag. */
export const DomainRow = ({ domain, priceLabel, free, selected, onSelect }: DomainRowProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <Row type="button" $selected={selected} onClick={onSelect}>
      <Domain text={domain} tag="span" />
      <PriceCluster>
        {free ? null : <Price text={priceLabel} tag="span" />}
        <FreeTag text={t('Free')} tag="span" />
      </PriceCluster>
    </Row>
  );
};

export default DomainRow;